import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { start } from './beacon'
import { CalendarProvider } from './calendar/Data'
import { WriteTrouble } from './components/WriteTrouble'
import { SHARE_PAGE } from './share/SharePage'
import { ViewerProvider } from './Viewer'
import './styles/tokens.css'
import './styles/base.css'

// Not on the card headless Chrome draws: its loads are a renderer's, not a reader's.
if (!location.pathname.startsWith(SHARE_PAGE)) start()

const root = document.getElementById('root')
if (!root) throw new Error('no #root to mount on')

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <ViewerProvider>
        <CalendarProvider>
          <App />
          <WriteTrouble />
        </CalendarProvider>
      </ViewerProvider>
    </BrowserRouter>
  </StrictMode>,
)
